import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_BALLAST',
  GET: 'GET_BALLAST',
  CREATE: 'CREATE_BALLAST',
  EDIT: 'EDIT_BALLAST',
  DELETE: 'DELETE_BALLAST',
  DUPLICATE: 'DUPLICATE_BALLAST',
  CLEAR_ERROR: 'CLEAR_ERROR_BALLAST',
};

export const clearErrorBallast = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

const fetchBallast = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_BALLAST,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const searchBallastByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = null;
  const isPublic = null;
  return fetchBallast(pageSize, page, sorted, filtered, isPublic)
    .catch(err => Promise.reject(err.response.data));
};

export const listBallastItems = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: fetchBallast(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getBallast = (id) => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_BALLAST}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createBallastItem = (name, brand_id, type_id, power_required, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('brand_id', brand_id);
  formData.set('type_id', type_id);
  formData.set('power_required', power_required);
  formData.set('description', description);
  if (image) formData.set('image', image, `photovoltaic_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_BALLAST,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editBallast = (id, name, brand_id, type_id, power_required, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (brand_id) formData.set('brand_id', brand_id);
  if (type_id) formData.set('type_id', type_id);
  if (power_required) formData.set('power_required', power_required);
  if (typeof(description) === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_BALLAST}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteBallast = ballastId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_BALLAST}${ballastId}/`,
    })
      .then(() => ({ id: ballastId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateBallast = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_BALLAST}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};


// WEBPACK FOOTER //
// ./src/redux/luminaire/ballast_actions.js